export default function SynopsisSection() {
  return (
    <section id="synopsis" className="py-32 px-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-amber-600 text-sm font-semibold tracking-wider uppercase mb-4">
            SYNOPSIS
          </p>
          <h2 
            className="text-5xl font-black text-gray-900"
            style={{ fontFamily: "'Noto Serif KR', serif" }}
          >
            시놉시스
          </h2>
        </div>
        
        <div className="bg-white rounded-3xl shadow-xl p-12 border border-gray-100">
          <div className="grid grid-cols-5 gap-8 items-center">
            <div className="col-span-3 space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                평범한 삶을 살던 주인공 <strong className="text-gray-900">김민준</strong>은 우연한 사건으로 <strong className="text-amber-600">'신공(新功)'</strong>이라 불리는 특별한 능력을 계승하게 됩니다.
              </p>
              
              <p className="text-lg text-gray-700 leading-relaxed">
                이 능력은 단순한 무술이 아닌, 인간의 한계를 뛰어넘는 초월적 힘입니다. 그러나 이 힘은 동시에 거대한 책임을 의미했습니다.
              </p>
              
              <p className="text-lg text-gray-700 leading-relaxed">
                그 속에서 펼쳐지는 <strong className="text-gray-900">인간의 욕망과 배신</strong>. 그는 이 능력을 이용해 거대한 <strong className="text-gray-900">부패한 세력</strong>에 맞서 싸우기로 결심합니다. 하지만 정의를 위한 싸움의 대가는 고독과 희생이었습니다.
              </p>
              
              <p className="text-lg text-gray-700 leading-relaxed">
                사랑하는 사람들을 지키기 위해, 그리고 무너져가는 세상을 바로 세우기 위해, 김민준은 홀로 어둠 속으로 걸어 들어갑니다.
              </p>
              
              <div className="pt-6 border-t border-gray-200">
                <p className="text-base text-gray-600 italic">
                  "영웅은 태어나는 것이 아니라, 선택하는 것이다."
                </p>
              </div>
            </div>
            
            <div className="col-span-2">
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://public.readdy.ai/ai/img_res/2d6073ec3794973d9e4d1d77c49e4af1.jpg"
                  alt="신공 시놉시스 이미지"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}